export const FLASH_BET_EVENT_TYPES = [
    { value: 'GOAL', label: 'Goal' },
    { value: 'YELLOW_CARD', label: 'Yellow card' },
    { value: 'RED_CARD', label: 'Red card' },
    { value: 'SUBSTITUTION', label: 'Substitution' },
    { value: 'CORNER', label: 'Corner' },
    { value: 'PENALTY_MISSED', label: 'Missed penalty' },
    { value: 'OFFSIDE', label: 'Offside' },
    { value: 'HALF_TIME', label: 'Half time' },
    { value: 'SHOT_ON_TARGET', label: 'Shot on target' },
    { value: 'SHOT_OFF_TARGET', label: 'Shot off target' },
    { value: 'ASSIST', label: 'Assist' },
    { value: 'OTHER', label: 'Other' },
] as const;

export type FlashBetEventType = typeof FLASH_BET_EVENT_TYPES[number]['value'];

export const DEFAULT_FLASH_BET_EVENT_TYPE: FlashBetEventType = 'OTHER';
